import axios from 'axios';

import React, { useEffect, useRef } from 'react';
import * as api from './api';

function ChatWindow({
  messages,
  setMessages,
  input,
  setInput,
  isTyping,
  setIsTyping,
  status,
  setStatus,
}) {
  const messagesEndRef = useRef(null);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Scroll to the bottom of the chat
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSend = async () => {
    if (input.trim()) {
      const newMessages = [...messages, { sender: 'You', text: input }];
      setMessages(newMessages);
      setInput('');
      setStatus('Sending...');

      await delay(1000);
      setStatus('Message sent');
      await delay(1500);
      setStatus('Read');
      setTimeout(() => setIsTyping(true), 1000);

      await delay(4000);

      try {
        // Check if the message asks for city-based search
        const cityMatch = input.match(/nicest cities near (.+)/i);
        let response;
        if (cityMatch) {
          const cityName = cityMatch[1].trim().replace(/[.,!?;:]$/, '');
          const cities = await searchNiceCities(cityName);
          response = await api.chatWithLuceniaData(newMessages, cities);
        } else {
          response = await api.chat(newMessages);
        }

        //const response = await api.chat(newMessages);
        let reply =
          response.data.choices[0]?.message?.content ||
          'Oh dear, I got distracted by the elves! What were we talking about? 🎅';

        setMessages((prev) => [...prev, { sender: 'Mrs. Claus', text: reply }]);
        setStatus('');
      } catch (error) {
        console.error('Error:', error);
        setMessages((prev) => [
          ...prev,
          {
            sender: 'Mrs. Claus',
            text: 'Oops, I lost my connection to the North Pole. Try again, sweetie! 🎄',
          },
        ]);
        setStatus('');
      } finally {
        setIsTyping(false);
      }
    }
  };

  const searchNiceCities = async (cityName) => {
    // Step 1: Geocode the city
    const coordinates = await api.geocodeCity(cityName);
    // Step 2: Fetch nice cities near the coordinates
    const response = await api.fetchNiceCitiesNear(coordinates);
    console.log('Response received from Lucenia Chat:', response.data);

    return response.data.hits.hits.map((hit) => hit._source);
  };


  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSend();
    }
  };

  // Scroll to the bottom on mount or when messages change
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <div className="chat-container">
      <h2 className="chat-title">Chat with the North Pole</h2>
      <div className="messages-container">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`message ${
              msg.sender === 'You' ? 'sent' : msg.system ? 'system' : 'received'
            }`}
          >
            <strong>{msg.sender !== 'System' ? `${msg.sender}: ` : ''}</strong>
            <em>{msg.text}</em>
          </div>
        ))}
        {status && (
          <div className="message system">
            <em>{status}</em>
          </div>
        )}
        {isTyping && (
          <div className="message received">
            <strong>Mrs. Claus:</strong> Mrs. Claus is typing...
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
      <div className="input-container">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder="Type your message..."
        />
        <button onClick={handleSend} disabled={isTyping}>
          {isTyping ? '...' : 'Send'}
        </button>
      </div>
    </div>
  );
}

export default ChatWindow;
